var _style, _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPollBackgroundImage(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1200 628",
    style: {
      enableBackground: "new 0 0 1200 628"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{clip-path:url(#SVGID_00000137114062824170008210000003417636295979408310_);}\n\t.st1{fill:none;stroke:#F0F0F0;stroke-miterlimit:10;}\n\t.st2{fill:#44B4B8;}\n\t.st3{fill:#FF7975;}\n\t.st4{fill:#3B9DA1;}\n\t.st5{fill:#2F7D80;}\n\t.st6{fill:#D0F1F2;}\n\t.st7{fill:#8DC2C4;}\n\t.st8{fill:#FFFFFF;}\n\t.st9{fill:#3B3E54;}\n\t.st10{fill:#7C7F94;}\n\t.st11{fill:#292B3B;}\n\t.st12{fill:#FE5E5A;}\n\t.st13{fill:#FF8B87;}\n\t.st14{fill:#EB4844;}\n\t.st15{fill:#BCF0F2;}\n\t.st16{fill:#ED976D;}\n\t.st17{fill:#F6B291;}\n\t.st18{fill:#1A1C2E;}\n\t.st19{fill:#E6E6E6;}\n\t.st20{fill:#C74A46;}\n\t.st21{fill:#222330;}\n\t.st22{fill:#E89F7B;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M1080.857,529.168c0,36.65-11.219,70.674-30.418,98.832H183.491c-33.941-40.823-54.348-93.305-54.348-150.536 c0-127.749,101.66-231.742,228.494-235.522C411.802,150.404,511.521,89,625.59,89c121.508,0,226.728,69.658,277.956,171.208 c7.742-2.992,16.143-4.658,24.946-4.658c38.16,0,69.091,30.931,69.091,69.091c0,17.515-6.534,33.493-17.277,45.673 C1039.751,398.49,1080.857,459.025,1080.857,529.168z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M323.573,147.699c-29.708,0-54.762,19.925-62.529,47.14h125.058 C378.335,167.624,353.281,147.699,323.573,147.699z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M494.162,147.699c-29.708,0-54.762,19.925-62.529,47.14h125.058 C548.924,167.624,523.87,147.699,494.162,147.699z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M412.889,127.505c-42.435,0-78.221,28.46-89.316,67.334h178.632 C491.111,155.966,455.324,127.505,412.889,127.505z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M683.413,485.885c-15.734,0-29.002,10.552-33.116,24.966h66.232 C712.416,496.437,699.147,485.885,683.413,485.885z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M773.758,485.885c-15.734,0-29.002,10.552-33.116,24.966h66.232 C802.76,496.437,789.492,485.885,773.758,485.885z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M730.716,475.19c-22.474,0-41.427,15.073-47.302,35.661h94.605C772.142,490.263,753.19,475.19,730.716,475.19 z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st5",
    d: "M879.365,548.928h-558.73c-10.326,0-18.697-8.371-18.697-18.696l0,0c0-10.326,8.371-18.697,18.697-18.697 h558.73c10.326,0,18.697,8.371,18.697,18.697l0,0C898.062,540.557,889.691,548.928,879.365,548.928z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st6",
    points: "557.021,474.19 554.384,508.913 645.617,508.913 642.979,474.19  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st7",
    points: "641.531,455.126 558.469,455.126 557.021,474.19 642.979,474.19  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M668.595,520.828h-137.19v-7.132c0-4.333,3.513-7.846,7.846-7.846h121.497c4.333,0,7.846,3.513,7.846,7.846 V520.828z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M801.81,169.172H398.19c-6.801,0-12.315,5.514-12.315,12.315v242.32h253.954h174.296V249.512v-68.024 C814.125,174.686,808.612,169.172,801.81,169.172z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M639.829,423.808H385.875v29.216c0,6.802,5.514,12.315,12.315,12.315h200.108H801.81 c6.801,0,12.315-5.514,12.315-12.315v-29.216H639.829z"
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st10",
    points: "550.577,184.155 400.861,184.155 400.861,333.871 400.861,406.777 796.422,406.777 796.422,184.155  "
  })), /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M461.977,233.488c-1.104,0-2,0.896-2,2v20.725H429.04v-20.725c0-1.104-0.896-2-2-2c-1.105,0-2,0.896-2,2 v296.051c0,1.104,0.895,2,2,2c1.104,0,2-0.896,2-2v-19.372h30.937v19.372c0,1.104,0.896,2,2,2s2-0.896,2-2V235.488 C463.977,234.383,463.081,233.488,461.977,233.488z M459.977,328.928v18.905H429.04v-18.905H459.977z M429.04,324.928v-18.905 h30.937v18.905H429.04z M459.977,351.833v18.904H429.04v-18.904H459.977z M459.977,374.737v18.905H429.04v-18.905H459.977z  M459.977,397.643v18.904H429.04v-18.904H459.977z M459.977,420.547v18.905H429.04v-18.905H459.977z M459.977,443.452v18.905 H429.04v-18.905H459.977z M459.977,302.023H429.04v-18.905h30.937V302.023z M429.04,466.357h30.937v18.904H429.04V466.357z  M459.977,260.213v18.905H429.04v-18.905H459.977z M429.04,508.167v-18.905h30.937v18.905H429.04z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 531.405,
    y: 279.118,
    className: "st12",
    width: 137.19,
    height: 127.977
  }), /*#__PURE__*/React.createElement("rect", {
    x: 531.405,
    y: 255.333,
    className: "st13",
    width: 137.19,
    height: 23.785
  }), /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M639.333,271.559h-78.667c-2.393,0-4.333-1.94-4.333-4.333v0c0-2.393,1.94-4.333,4.333-4.333h78.667 c2.393,0,4.333,1.94,4.333,4.333v0C643.667,269.619,641.727,271.559,639.333,271.559z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st8",
    points: "604.473,161.613 544.74,240.786 585.528,271.559 610.045,271.559 660.885,204.174  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M592.631,216.051l-10.644-8.03l8.03-10.644l10.643,8.03L592.631,216.051z M584.788,207.629l7.451,5.621 l5.621-7.451l-7.45-5.621L584.788,207.629z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M607.492,194.693l-9.047-6.826c-0.441-0.333-0.529-0.96-0.196-1.4l6.826-9.047 c0.333-0.441,0.959-0.529,1.4-0.196l9.047,6.826c0.441,0.333,0.529,0.96,0.196,1.4l-6.826,9.047 C608.56,194.938,607.933,195.026,607.492,194.693z M600.447,186.873l7.45,5.621l5.621-7.451l-7.45-5.621L600.447,186.873z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M576.173,236.204l-9.047-6.826c-0.441-0.333-0.529-0.96-0.196-1.401l6.826-9.047 c0.333-0.441,0.959-0.529,1.401-0.196l9.047,6.826c0.441,0.333,0.529,0.96,0.196,1.401l-6.826,9.047 C577.241,236.449,576.615,236.537,576.173,236.204z M569.129,228.384l7.45,5.621l5.621-7.451l-7.45-5.621L569.129,228.384z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 614.342,
    y: 198.988,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 247.6286 -338.3967)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 610.829,
    y: 203.644,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 249.7245 -335.3414)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 599.435,
    y: 218.745,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 256.5201 -325.4328)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 595.922,
    y: 223.402,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 258.6173 -322.3783)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 584.529,
    y: 238.503,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 265.4126 -312.4695)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 581.016,
    y: 243.16,
    transform: "matrix(0.7983 0.6023 -0.6023 0.7983 267.5089 -309.4145)",
    className: "st13",
    width: 29.333,
    height: 3
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M602,208.194c-0.109-0.782-0.831-1.326-1.613-1.217l-7.255,1.016l-0.782-5.588 c-0.109-0.782-0.831-1.326-1.612-1.217c-0.782,0.109-1.326,0.831-1.217,1.613l1.003,7.17c0.055,0.391,0.263,0.722,0.554,0.942 c0.292,0.22,0.668,0.329,1.058,0.274c0.26-0.036,0.49-0.145,0.682-0.297c0.097,0.007,0.196,0.004,0.296-0.01l7.669-1.074 C601.565,209.698,602.11,208.976,602,208.194z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M577.73,231.115l4.42-0.618c0.808-0.113,1.371-0.859,1.258-1.667c-0.113-0.808-0.859-1.371-1.667-1.258 l-4.42,0.618l-0.619-4.42c-0.113-0.808-0.859-1.371-1.667-1.258c-0.808,0.113-1.371,0.859-1.258,1.667l0.619,4.42l-4.42,0.619 c-0.808,0.113-1.371,0.859-1.258,1.667c0.057,0.404,0.271,0.747,0.573,0.974s0.69,0.34,1.094,0.283l4.42-0.619l0.618,4.42 c0.057,0.404,0.271,0.747,0.573,0.974c0.302,0.228,0.69,0.34,1.094,0.283c0.808-0.113,1.371-0.859,1.258-1.667L577.73,231.115z"
  })), /*#__PURE__*/React.createElement("rect", {
    x: 770.5,
    y: 437.5,
    className: "st10",
    width: 29,
    height: 9.5
  }), /*#__PURE__*/React.createElement("rect", {
    x: 733.5,
    y: 437.5,
    className: "st12",
    width: 29,
    height: 9.5
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M792.341,286.747c-14.178,0-26.134,9.509-29.841,22.496h59.681 C818.475,296.256,806.518,286.747,792.341,286.747z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M873.75,286.747c-14.177,0-26.134,9.509-29.841,22.496h59.681 C899.884,296.256,887.928,286.747,873.75,286.747z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M834.965,277.11c-20.251,0-37.329,13.582-42.624,32.134h85.248 C872.294,290.692,855.216,277.11,834.965,277.11z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M215.888,184.71c-17.165,0-31.641,11.512-36.128,27.237h72.257 C247.529,196.222,233.053,184.71,215.888,184.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M314.451,184.71c-17.165,0-31.641,11.512-36.128,27.237h72.257 C346.092,196.222,331.616,184.71,314.451,184.71z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st15",
    d: "M267.493,173.042c-24.518,0-45.195,16.444-51.605,38.904h103.211 C312.688,189.486,292.012,173.042,267.493,173.042z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M824.202,350.17c0,0-6.913-6.706-9.319-6.399c-2.406,0.306,3.451,7.433,9.119,8.763L824.202,350.17z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M822.572,348.389c-0.823,1.298-1.619,2.572-2.355,3.879c20.9,12.541,32.195,16.809,56.265,11.967 c3.682-0.741,3.817-2.167,2.702-5.031c0.493-0.368,0.506-0.346,0,0c-1.115-2.864-2.081-2.926-5.664-2.16 C850.099,362.053,844.036,357.728,822.572,348.389z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 799.623,
    y: 335.58,
    transform: "matrix(0.7779 -0.6284 0.6284 0.7779 -56.5744 610.2925)",
    className: "st8",
    width: 70.667,
    height: 99.179
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M826.25,393.488l-10.371,8.379l-8.379-10.372l10.371-8.379L826.25,393.488z M816.178,399.055l7.26-5.865 l-5.866-7.26l-7.26,5.865L816.178,399.055z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M809.133,373.893l-8.815,7.122c-0.43,0.347-1.059,0.28-1.406-0.149l-7.122-8.816 c-0.347-0.43-0.281-1.059,0.149-1.406l8.815-7.122c0.43-0.347,1.059-0.28,1.406,0.149l7.123,8.816 C809.629,372.916,809.563,373.546,809.133,373.893z M799.838,378.831l7.26-5.865l-5.866-7.26l-7.26,5.865L799.838,378.831z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M841.812,414.341l-8.815,7.122c-0.43,0.347-1.059,0.28-1.406-0.149l-7.123-8.816 c-0.347-0.43-0.28-1.059,0.149-1.406l8.815-7.122c0.43-0.347,1.059-0.28,1.406,0.149l7.123,8.816 C842.308,413.364,842.242,413.994,841.812,414.341z M832.518,419.279l7.26-5.865l-5.866-7.26l-7.26,5.865L832.518,419.279z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 805.305,
    y: 352.923,
    transform: "matrix(0.7779 -0.6284 0.6284 0.7779 -40.5804 594.0458)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 808.97,
    y: 357.46,
    transform: "matrix(0.7779 -0.6284 0.6284 0.7779 -42.6181 597.3558)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 820.859,
    y: 372.175,
    transform: "matrix(0.7779 -0.6284 0.6284 0.7779 -49.2239 608.0975)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 824.525,
    y: 376.712,
    transform: "matrix(0.7778 -0.6285 0.6285 0.7778 -51.2604 611.4117)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 836.413,
    y: 391.426,
    transform: "matrix(0.7779 -0.6284 0.6284 0.7779 -57.8678 622.1473)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 840.079,
    y: 395.964,
    transform: "matrix(0.7778 -0.6285 0.6285 0.7778 -59.9039 625.4636)",
    className: "st13",
    width: 29.333,
    height: 3
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M820.9,382.494c-0.785-0.083-1.488,0.485-1.571,1.27l-0.774,7.285l-5.611-0.596 c-0.785-0.083-1.488,0.485-1.571,1.269c-0.083,0.785,0.485,1.488,1.27,1.572l7.199,0.765c0.392,0.042,0.764-0.08,1.049-0.309 c0.284-0.23,0.481-0.568,0.523-0.96c0.028-0.261-0.022-0.51-0.122-0.734c0.03-0.092,0.051-0.189,0.062-0.289l0.818-7.701 C822.253,383.28,821.684,382.577,820.9,382.494z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M836.74,402.099c-0.785-0.083-1.488,0.485-1.571,1.27l-0.774,7.285l-5.611-0.596 c-0.785-0.083-1.488,0.485-1.572,1.269c-0.083,0.785,0.485,1.488,1.27,1.572l7.199,0.765c0.392,0.042,0.764-0.079,1.049-0.309 c0.284-0.23,0.481-0.568,0.523-0.96c0.028-0.261-0.022-0.511-0.122-0.734c0.03-0.092,0.051-0.189,0.062-0.289l0.818-7.701 C838.093,402.886,837.524,402.182,836.74,402.099z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M804.484,362.175c-0.785-0.083-1.488,0.485-1.571,1.27l-0.774,7.285l-5.611-0.596 c-0.785-0.083-1.488,0.485-1.572,1.269c-0.083,0.785,0.485,1.488,1.27,1.572l7.199,0.765c0.392,0.042,0.764-0.079,1.049-0.309 c0.284-0.23,0.481-0.568,0.523-0.96c0.028-0.261-0.022-0.51-0.123-0.734c0.03-0.092,0.051-0.189,0.062-0.289l0.818-7.701 C805.837,362.962,805.268,362.258,804.484,362.175z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M946.414,464.439c0.01-0.123,0.007-0.249-0.009-0.376c-0.126-1.024-1.059-1.752-2.082-1.625l-13.332,1.644 c-1.023,0.126-1.752,1.06-1.625,2.082c0.126,1.024,1.059,1.752,2.082,1.625l13.332-1.644 C945.677,466.034,946.346,465.306,946.414,464.439z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M942.678,462.256c0,0,4.092-2.767,4.623-1.731c0.53,1.036,6.841,16.447,6.153,16.809 c-2.352,1.237-9.403-10.653-9.621-11.996C943.615,463.994,942.078,462.642,942.678,462.256z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M872.154,520.99c0.124,0,0.249-0.012,0.375-0.038c1.011-0.206,1.664-1.192,1.458-2.203l-2.68-13.163 c-0.206-1.011-1.194-1.664-2.203-1.458c-1.011,0.206-1.663,1.192-1.458,2.203l2.68,13.163 C870.506,520.38,871.285,520.99,872.154,520.99z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st14",
    d: "M868.043,513.335c1.991-0.051,3.979-0.253,5.948-0.548c-5.919-31.641-10.4-74.109,5.43-103.683 c-4.805-2.357-9.638-4.661-14.479-6.943C853.374,427.929,863.226,486.116,868.043,513.335z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M939.199,468.189c-0.225-1.991-0.535-3.963-0.925-5.929c-46.817,6.087-64.818-8.064-54.645-57.647 c-5.275-1.428-10.575-2.742-15.876-4.069C863.165,456.286,886.257,474.537,939.199,468.189z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M868.874,333.982c1.84-1.097,4.713-1.031,6.199,0.455s0.906,4.107-0.61,5.624 c-1.516,1.517-5.988,1.544-7.474,0.058C865.503,338.633,866.545,335.372,868.874,333.982z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M893.039,343.367c2.529-3.402,8.043-5.435,12.17-3.811c4.127,1.624,5.329,6.889,3.781,10.822 c-1.547,3.932-8.338,7.851-14.681,5.873C890.076,354.93,889.837,347.674,893.039,343.367z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M889.795,341.126c1.854-2.558,5.833-4.134,8.773-2.977c2.94,1.157,3.739,5.054,2.582,7.994 c-1.157,2.94-7.269,5.57-10.209,4.413C888.002,349.4,887.447,344.365,889.795,341.126z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M876.505,334.861c0,0,5.757,4.448,9.474,4.039c3.718-0.409,5.657-1.099,9.234,2.18 c3.577,3.28,6.751-1.57,9.35,2.859c2.599,4.429-4.57,15.737-12.455,11.512c-6.494-3.481-4.637-5.107-9.195-4.718 c-1.8,0.154-5.067-0.131-7.761-2.586C872.46,345.691,876.505,334.861,876.505,334.861z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M881.28,343.205c0,5.651-3.936,10.232-7.39,10.232c-3.453,0-5.116-4.581-5.116-10.232 c0-5.651,2.799-8.526,6.253-8.526C878.48,334.678,881.28,337.554,881.28,343.205z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M883.825,345.149c0,1.315-1.306,2.997-2.258,2.997c-0.952,0-1.191-1.066-1.191-2.382 c0-1.315,0.772-2.546,1.725-2.546C883.053,343.219,883.825,343.834,883.825,345.149z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M882.1,339.606c0,0-1.194-3.62-4.026-4.927c-2.831-1.307-8.289-1.082-9.469,3.927 c0,0-0.512,3.635,3.925,3.881c4.437,0.246,3.49-2.014,5.792,0c2.303,2.014,4.12,0.262,4.558,0.733L882.1,339.606z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M861.4,415.036c3.493,0.081,8.042-0.663,12.336-2.825c3.303-1.66,7.102-2.237,10.244-2.375 c0.79-11.31,2.663-41.113,0.876-46.613c-2.219-6.82-6.18-9.713-6.18-9.713s-2.519,2.214-4.393,2.046 c-1.874-0.173-4.058,6.255-6.641,10.348c-2.588,4.093-4.715,5.459-2.508,11.725C866.081,380.327,860.933,411.11,861.4,415.036z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M881.013,346.26l-5.906-0.577c-0.08,0.809-0.698,8.51-0.398,11.412c0.217,0.894,1.69,1.304,3.289,0.916 c1.438-0.349,2.48-1.224,2.52-2.046l0.007-0.001C880.345,354.223,880.738,349.085,881.013,346.26z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M874.491,518.509c0,0,1.156,4.803,0,4.936c-1.156,0.133-17.802,0.638-17.899-0.133 c-0.333-2.636,13.274-5.07,14.608-4.803C872.534,518.776,874.339,517.811,874.491,518.509z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M839.81,381.216c0,0-7.827-6.404-10.317-5.87c-2.49,0.534,4.269,7.471,10.317,8.36V381.216z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M838.973,380.261c-0.646,1.389-1.322,2.853-1.985,4.095c24.362,11.29,42.278,13.544,48.35-16.379 c0.929-4.577-1.033-3.756-2.971-5.221c-3.302,0.566-4.133-0.132-4.726,4.148C873.764,394.886,860.065,386.24,838.973,380.261z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M367.72,459.991c-0.081-0.102-0.153-0.214-0.215-0.334c-0.494-0.969-0.109-2.155,0.859-2.649l12.615-6.435 c0.969-0.494,2.156-0.108,2.649,0.859c0.494,0.969,0.109,2.155-0.859,2.649l-12.615,6.436 C369.306,460.948,368.291,460.707,367.72,459.991z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M370.723,456.129c0,0-5.034-1.335-5.203-0.119c-0.169,1.215-1.104,18.747-0.292,18.868 c2.771,0.415,5.664-13.868,5.415-15.28C370.394,458.185,371.454,456.306,370.723,456.129z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M476.858,322.727c0,0,6.979-7.375,9.527-7.16c2.548,0.214-3.3,7.984-9.21,9.641L476.858,322.727z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M479.699,319.588c0.733,1.474,1.502,2.871,2.229,4.284c-22.23,12.286-37.478,11.162-55.997-5.478 c-2.833-2.545-2.302-3.779,0.043-5.923c-0.135-0.574-0.171-0.543,0,0c2.345-2.144,3.345-2.012,6.225,0.568 C451.024,329.913,455.971,327.901,479.699,319.588z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M434.771,481.878c-0.13,0-0.263-0.013-0.395-0.04c-1.066-0.217-1.754-1.257-1.537-2.322l2.826-13.877 c0.217-1.065,1.259-1.754,2.322-1.537c1.066,0.217,1.754,1.257,1.537,2.322l-2.825,13.877 C436.508,481.234,435.687,481.878,434.771,481.878z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M439.105,473.807c-2.099-0.054-4.195-0.267-6.271-0.578c6.24-33.357,10.964-78.129-5.724-109.306 c5.066-2.485,10.161-4.913,15.265-7.319C454.569,383.769,444.183,445.112,439.105,473.807z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M377.455,458.595c-1.231-1.805-2.412-3.63-3.483-5.535c39.197-22.09,61.358-46.02,48.628-93.747 c5.622-1.453,11.277-2.805,16.962-3.99C443.12,409.879,422.237,432.345,377.455,458.595z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M432.307,479.261c0,0-1.219,5.063,0,5.204c1.219,0.141,18.767,0.673,18.87-0.141 c0.352-2.779-13.994-5.345-15.401-5.063C434.37,479.543,432.467,478.526,432.307,479.261z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M421.917,367.206c2.717-1.075,6.644-2.115,13.491-2.408c4.652-0.197,8.304-0.034,11.162,0.349 c-11.977-25.704-14.053-38.514-12.967-45.732c0.54-3.601-0.866-7.212-3.752-9.423l-1.125-0.866 c-5.232-4.017-12.889-1.148-14.143,5.333c-0.422,2.166-0.743,4.641-0.889,7.437C413.006,335.172,414.773,349.614,421.917,367.206 z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420.109,299.89c4.233,4.192,10.584,4.642,13.146,2.055c2.562-2.587,0.364-7.23-3.869-11.422 c-4.233-4.192-8.464-4.228-11.025-1.641S415.876,295.698,420.109,299.89z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M420.673,298.247l6.227-0.608c0.084,0.852,0.736,8.971,0.42,12.031c-0.229,0.943-1.781,1.375-3.468,0.966 c-1.516-0.368-2.615-1.29-2.657-2.157l-0.007-0.001C421.378,306.642,420.964,301.226,420.673,298.247z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M433.097,295.446c0,0-0.066,0.055-0.183,0.155c-0.938,0.806-5.173,4.558-5.229,6.659 c-0.063,2.362,2.405-1.429,3.043-3.073c0.639-1.644,1.832-1.7,2.799-2.226C434.494,296.433,434.686,295.04,433.097,295.446z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 428.485,
    y: 304.573,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 128.9739 -123.7891)",
    className: "st8",
    width: 70.667,
    height: 99.179
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M452.078,351.483l-12.707-4.036l4.036-12.708l12.707,4.036L452.078,351.483z M441.883,346.146 l8.895,2.825l2.825-8.895l-8.895-2.825L441.883,346.146z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M458.996,326.4l-10.801-3.431c-0.527-0.167-0.818-0.729-0.65-1.256l3.431-10.802 c0.167-0.526,0.729-0.818,1.256-0.65l10.801,3.431c0.527,0.167,0.818,0.729,0.65,1.256l-3.431,10.802 C460.085,326.276,459.523,326.567,458.996,326.4z M449.753,321.366l8.895,2.825l2.825-8.896l-8.895-2.825L449.753,321.366z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M443.255,375.96l-10.801-3.431c-0.527-0.167-0.818-0.729-0.65-1.256l3.431-10.802 c0.167-0.526,0.729-0.818,1.256-0.65l10.801,3.431c0.527,0.167,0.818,0.729,0.65,1.256l-3.431,10.802 C444.343,375.836,443.781,376.127,443.255,375.96z M434.012,370.926l8.895,2.825l2.825-8.896l-8.895-2.825L434.012,370.926z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 466.549,
    y: 323.214,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 120.8764 -130.438)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 464.783,
    y: 328.773,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 122.4765 -129.6426)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 459.057,
    y: 346.802,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 127.6656 -127.0632)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 457.291,
    y: 352.362,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 129.2642 -126.2666)",
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 451.564,
    y: 370.391,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 134.4532 -123.6872)",
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 449.799,
    y: 375.951,
    transform: "matrix(0.9531 0.3027 -0.3027 0.9531 136.0529 -122.8915)",
    className: "st13",
    width: 29.333,
    height: 3
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M466.033,316.625c-0.363-0.701-1.225-0.974-1.925-0.612l-6.505,3.369l-2.595-5.011 c-0.363-0.701-1.225-0.974-1.925-0.612c-0.701,0.363-0.975,1.225-0.612,1.926l3.329,6.429c0.181,0.35,0.488,0.594,0.836,0.705 c0.348,0.111,0.739,0.088,1.089-0.093c0.233-0.121,0.414-0.3,0.545-0.507c0.093-0.026,0.186-0.061,0.275-0.108l6.876-3.561 C466.122,318.187,466.396,317.325,466.033,316.625z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M443.031,370.643l3.963-2.052c0.724-0.375,1.008-1.266,0.632-1.99c-0.375-0.725-1.266-1.007-1.99-0.632 l-3.963,2.052l-2.052-3.963c-0.375-0.724-1.266-1.007-1.991-0.632c-0.724,0.375-1.007,1.266-0.632,1.991l2.052,3.963 l-3.963,2.052c-0.724,0.375-1.008,1.266-0.632,1.99c0.188,0.362,0.504,0.614,0.864,0.728c0.36,0.114,0.764,0.091,1.126-0.096 l3.963-2.052l2.052,3.963c0.188,0.362,0.504,0.614,0.864,0.728c0.36,0.114,0.764,0.091,1.126-0.096 c0.724-0.375,1.008-1.266,0.632-1.991L443.031,370.643z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M450.978,345.624l3.963-2.052c0.724-0.375,1.008-1.266,0.632-1.991c-0.375-0.725-1.266-1.007-1.991-0.632 l-3.963,2.052l-2.052-3.963c-0.375-0.724-1.266-1.007-1.99-0.632c-0.724,0.375-1.008,1.266-0.632,1.991l2.052,3.963l-3.963,2.052 c-0.724,0.375-1.007,1.266-0.632,1.99c0.188,0.362,0.504,0.614,0.864,0.729c0.36,0.114,0.764,0.091,1.126-0.096l3.963-2.052 l2.052,3.963c0.188,0.362,0.504,0.614,0.864,0.728c0.36,0.114,0.764,0.091,1.126-0.096c0.724-0.375,1.008-1.266,0.632-1.99 L450.978,345.624z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st19",
    d: "M453.328,343.9c0,0,9.315-5.185,11.8-4.167c2.484,1.018-5.823,6.956-12.264,6.751L453.328,343.9z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M455.165,342.176c0.38,1.625,0.77,3.24,1.196,4.702c-26.722,6.463-47.554,1.605-41.379-29.796 c0.945-4.803,1.921-3.792,4.777-3.344c0.686-0.364,0.416-0.327,0,0c2.857,0.448,4.462,1.041,3.251,5.362 C415.095,347.353,433.816,343.48,455.165,342.176z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M416.805,297.835c0,0-1.826-3.58-0.705-6.671c1.121-3.091,5.338-7.012,9.966-4.18 c0,0,3.103,2.313-0.004,5.819c-3.107,3.506-4.097,1.12-4.297,4.339c-0.199,3.219-2.86,3.28-2.832,3.958L416.805,297.835z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M419.678,303.239c0.985,0.976,3.214,1.245,3.921,0.532s0.085-1.683-0.901-2.659 c-0.985-0.976-2.48-1.31-3.186-0.597C418.805,301.229,418.692,302.263,419.678,303.239z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M423.445,300.917c0.686-1.165,1.72-0.474,4.142,0.27c2.418,0.748,6.214-0.406,5.386-5.517 c-0.527-3.256,2.428,1.613,2.432,1.617c0.937,2.561,0.569,4.313-0.951,5.848c-2.098,2.119-6.045,2.738-9.946,1.425 C423.676,303.386,422.975,301.711,423.445,300.917z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M440.989,158.822c-0.002-0.124,0.008-0.249,0.031-0.375c0.186-1.015,1.16-1.686,2.174-1.499l13.212,2.428 c1.014,0.186,1.686,1.162,1.5,2.174c-0.186,1.015-1.16,1.686-2.174,1.5l-13.212-2.428 C441.631,160.458,441.006,159.691,440.989,158.822z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M445.29,157.165c0,0-2.493-4.265-3.419-3.561c-0.926,0.705-13.282,11.869-12.818,12.494 c1.586,2.133,13.086-5.538,13.863-6.654C443.694,158.327,445.664,157.773,445.29,157.165z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M570.284,166.951c-0.122-0.022-0.243-0.056-0.362-0.103c-0.96-0.379-1.43-1.464-1.052-2.423l4.93-12.495 c0.379-0.959,1.465-1.43,2.423-1.052c0.96,0.379,1.431,1.464,1.052,2.423l-4.93,12.495 C572.013,166.636,571.14,167.102,570.284,166.951z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M567.744,164.595c0,0-1.061,4.825,0.097,4.935c1.159,0.111,17.811,0.288,17.893-0.486 c0.282-2.642-13.372-4.807-14.7-4.514C569.706,164.824,567.882,163.895,567.744,164.595z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st21",
    d: "M575.466,163.025l-6.224-3.205c5.598-10.878,12.414-28.602,10.042-33.946 c-0.246-0.554-0.505-0.715-0.897-0.819c-8.648-2.302-26.362,10.835-33.162,14.534l-5.173-10.191 c2.751-1.498,27.25-14.539,40.136-11.107c2.514,0.669,4.414,2.31,5.495,4.746C590.254,133.338,577.974,158.155,575.466,163.025z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M601.138,153.724c0,0,6.176,7.39,5.693,9.767c-0.483,2.377-7.157-3.991-8.064-9.742L601.138,153.724z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M601.866,153.283c-1.111,1.103-2.218,2.162-3.427,3.121c-16.753-21.348-21.701-27.962-24.53-54.842 c-0.433-4.112,1.288-4.396,4.273-3.766c0.186-0.741,0.181-0.743,0,0c2.985,0.63,3.005,1.837,3.347,5.503 C583.769,127.265,588.535,133.329,601.866,153.283z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st11",
    d: "M447.638,163.605c0.185-2.039,0.467-4.049,0.836-6.063c37.126,6.552,73.681,9.414,85.202-32.503 c5.249,1.233,10.481,2.52,15.697,3.884C529.959,174.862,491.765,173.189,447.638,163.605z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M602.632,92.38c-0.703-1.688-2.803-3.116-4.707-2.869c-1.903,0.247-2.963,2.325-2.729,4.132 c0.235,1.807,3.43,4.118,5.333,3.871C602.434,97.266,603.522,94.517,602.632,92.38z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M588.711,92.208c0.847-4.154-1.318-9.618-5.28-11.609s-8.687,0.627-10.584,4.403 c-1.897,3.776-0.285,11.449,5.42,14.854C582.074,102.129,587.639,97.467,588.711,92.208z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M592.544,93.13c0.668-3.088-0.812-7.104-3.635-8.522c-2.823-1.418-6.259,0.587-7.678,3.41 c-1.418,2.823,0.7,9.131,3.523,10.549C587.578,99.985,591.698,97.039,592.544,93.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M587.775,91.181c-3.448,4.477-3.123,10.508-0.388,12.615c2.736,2.107,6.848-0.508,10.296-4.986 c3.448-4.477,2.984-8.464,0.248-10.57C595.195,86.133,591.222,86.704,587.775,91.181z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M584.572,91.169c-0.802,1.042-0.794,3.172-0.039,3.753s1.594-0.118,2.397-1.16 c0.802-1.042,0.941-2.488,0.187-3.069C586.361,90.111,585.375,90.127,584.572,91.169z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M589.321,87.829c0,0,3.155-2.14,6.196-1.448c3.041,0.692,7.228,4.2,5.107,8.888c0,0-1.812,3.193-5.478,0.681 c-3.666-2.512-1.536-3.725-4.589-3.534c-3.053,0.191-3.424-2.306-4.058-2.2L589.321,87.829z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M547.223,142.956c-4.289-1.894-6.145-4.846-8.441-8.657c-1.765-2.93-5.019-5.603-6.68-8.434 c2.636-16.43,23.415-29.034,34.356-31.16c9.611-1.868,14.269-0.368,15.477,6.714c0.01,0.059,0.434,4.067-8.052,8.973 c-4.826,2.79-4.139,2.898-12.432,6.28C557.881,118.129,548.626,136.589,547.223,142.956z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M587.931,93.114l2.254,5.49c-0.751,0.309-7.948,3.12-10.814,3.669c-0.919,0.05-1.736-1.242-1.825-2.886 c-0.08-1.478,0.457-2.727,1.233-3.003l-0.001-0.007C580.497,96.048,585.304,94.192,587.931,93.114z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M593.747,162.002c0,0,9.504,3.456,10.317,5.87c0.814,2.413-8.603,0.147-12.458-4.597L593.747,162.002z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st22",
    d: "M594.739,161.615c-1.005,1.426-1.896,2.565-2.989,3.81c-25.125-27.207-25.7-30.881-26.094-66.201 c-0.06-5.403,7.675-4.82,7.009,3.938C570.325,133.912,574.47,136.255,594.739,161.615z"
  }))), /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M613.281,333.369c-1.19-1.19-3.118-1.19-4.308,0l-11.046,11.047l-8.508-8.509 c-1.19-1.19-3.118-1.189-4.308-0.001c-1.19,1.19-1.19,3.118,0,4.308l10.915,10.916c0.595,0.595,1.374,0.892,2.154,0.892 c0.779,0,1.559-0.297,2.154-0.892c0.396-0.396,0.648-0.876,0.78-1.381c0.173-0.113,0.338-0.245,0.49-0.397l11.677-11.677 C614.47,336.488,614.47,334.558,613.281,333.369z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M312.947,521.492c-0.124,0-0.249-0.013-0.375-0.038c-1.012-0.206-1.664-1.193-1.458-2.204l2.682-13.17 c0.206-1.011,1.195-1.664,2.204-1.458c1.011,0.206,1.664,1.193,1.458,2.204l-2.682,13.17 C314.595,520.881,313.816,521.492,312.947,521.492z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M310.609,519.009c0,0-1.157,4.805,0,4.939c1.157,0.134,17.811,0.639,17.909-0.133 c0.334-2.638-13.281-5.072-14.616-4.805C312.567,519.276,310.76,518.311,310.609,519.009z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M351.107,313.597c0,0-4.103-8.72-3.032-10.897c1.071-2.178,5.914,5.679,5.333,11.475L351.107,313.597z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M350.013,314.322c-0.186-1.393,3.184-1.777,4.223-1.904c5.634,28.645,5.011,26.272-6.657,53.308 c-1.785,4.135-3.391,2.662-5.863,0.434c-0.514,0.556-0.508,0.563,0,0c-2.473-2.228-1.47-2.991,0.445-6.672 C354.675,335.424,353.561,340.913,350.013,314.322z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M355.839,521.448c-0.121,0.026-0.246,0.041-0.374,0.043c-1.032,0.015-1.881-0.809-1.896-1.841l-0.199-13.439 c-0.015-1.032,0.811-1.882,1.841-1.896c1.032-0.015,1.881,0.809,1.896,1.841l0.199,13.439 C357.319,520.498,356.689,521.262,355.839,521.448z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st20",
    d: "M358.373,512.878c-1.954,0.504-3.907,0.96-5.891,1.329c-1.209-36.135-2.715-70.719-14.844-105.629 c5.066-1.76,10.144-3.465,15.252-5.1C361.824,439.31,357.17,476.67,358.373,512.878z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st12",
    d: "M317.711,512.309c-2.105,0.04-4.202,0.031-6.304-0.104c8.408-33.144,20.701-81.627,23.386-110.161 c5.329,0.669,10.655,1.403,15.955,2.276C341.115,443.127,324.285,471.129,317.711,512.309z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M353.53,518.875c0,0-1.157,4.805,0,4.939c1.157,0.133,17.811,0.639,17.909-0.133 c0.334-2.638-13.281-5.072-14.616-4.805C355.487,519.142,353.681,518.177,353.53,518.875z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st17",
    d: "M333.059,407.852c4.432,0.145,7.769,1.286,12.082,2.818c2.931,1.041,6.961,2.932,9.766,4.218 c-0.578-21.218-0.341-30.483-6.827-48.76c-3.235-9.117-8.419-8.905-8.74-8.957c-5.959-0.979-11.316,2.363-10.387,9.013 c0.31,2.223,0.798,2.849,1.951,5.783C336.378,385.898,334.26,393.455,333.059,407.852z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M314.282,315.707c0,0,2.059-9.906,0.433-11.869c-1.626-1.962-4.652,7.244-2.642,13.021L314.282,315.707z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M331.226,347.028c2.131,5.237,7.507,7.997,10.707,6.695c3.2-1.302,3.013-6.175,0.882-11.411 c-2.131-5.237-5.81-6.846-9.01-5.544C330.604,338.071,329.095,341.792,331.226,347.028z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M329.108,344.002c0,0-0.258-3.805,1.873-6.085c2.131-2.28,7.274-4.129,10.256,0.068 c0,0,1.846,3.176-2.173,5.077c-4.019,1.902-3.993-0.551-5.368,2.184c-1.374,2.735-3.719,1.796-3.948,2.398L329.108,344.002z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M332.137,347.214l5.91-0.577c0.08,0.809,0.699,8.514,0.399,11.418c-0.217,0.895-1.691,1.305-3.291,0.917 c-1.439-0.349-2.481-1.224-2.522-2.047l-0.007-0.001C332.806,355.181,332.413,350.041,332.137,347.214z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M329.601,349.79c0.496,1.219,2.341,2.285,3.223,1.926s0.701-1.437,0.205-2.656 c-0.496-1.219-1.676-2.068-2.558-1.709C329.588,347.71,329.104,348.571,329.601,349.79z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st18",
    d: "M343.788,351.33c0,0,1.335,1.131,0,2.534c-1.335,1.404-3.604,0.336-3.537-0.599 c0.067-0.934,1.215-0.4,1.742-0.934C342.52,351.797,343.431,350.889,343.788,351.33z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st16",
    d: "M314.91,314.615c-0.178-1.267-3.408-1.048-4.468-0.665c2.827,26.649,2.86,30.117,18.257,53 c2.355,3.5,8.862-0.648,3.771-7.352C318.088,340.656,318.313,338.798,314.91,314.615z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 296.089,
    y: 205.744,
    className: "st8",
    width: 70.667,
    height: 99.179
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M319.423,256.333H306.09V243h13.333V256.333z M308.09,254.333h9.333V245h-9.333V254.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.423,230.333H307.09c-0.553,0-1-0.448-1-1V218c0-0.552,0.447-1,1-1h11.333c0.553,0,1,0.448,1,1 v11.333C319.423,229.886,318.975,230.333,318.423,230.333z M308.09,228.333h9.333V219h-9.333V228.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st13",
    d: "M318.423,282.333H307.09c-0.553,0-1-0.448-1-1V270c0-0.552,0.447-1,1-1h11.333c0.553,0,1,0.448,1,1 v11.334C319.423,281.886,318.975,282.333,318.423,282.333z M308.09,280.333h9.333V271h-9.333V280.333z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 220.5,
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 226.333,
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 245.25,
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 251.083,
    className: "st13",
    width: 29.333,
    height: 3
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 270,
    className: "st13",
    width: 29.333,
    height: 3
  }), /*#__PURE__*/React.createElement("rect", {
    x: 324.423,
    y: 275.833,
    className: "st13",
    width: 29.333,
    height: 3
  })))), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M322.17,244.419c-0.558-0.558-1.462-0.558-2.02,0l-5.18,5.181l-3.99-3.99c-0.558-0.558-1.462-0.558-2.02,0 c-0.558,0.558-0.558,1.462,0,2.02l5.119,5.119c0.279,0.279,0.645,0.419,1.01,0.419c0.366,0,0.731-0.139,1.01-0.418 c0.186-0.186,0.304-0.411,0.366-0.648c0.081-0.053,0.159-0.115,0.23-0.186l5.476-5.476 C322.728,245.881,322.728,244.976,322.17,244.419z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st9",
    d: "M316.6,277.333l3.156-3.156c0.577-0.577,0.577-1.512,0-2.089c-0.577-0.577-1.512-0.577-2.089,0l-3.156,3.156 l-3.156-3.156c-0.577-0.577-1.512-0.577-2.089,0c-0.577,0.577-0.577,1.512,0,2.089l3.156,3.156l-3.156,3.156 c-0.577,0.577-0.577,1.512,0,2.089c0.289,0.288,0.666,0.433,1.044,0.433c0.378,0,0.756-0.144,1.044-0.433l3.156-3.156l3.156,3.156 c0.288,0.288,0.666,0.433,1.044,0.433c0.378,0,0.756-0.144,1.044-0.433c0.577-0.577,0.577-1.512,0-2.089L316.6,277.333z"
  })), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M691.706,271c3.785,0,6.852-3.068,6.852-6.852c0,3.784,3.068,6.852,6.853,6.852 c-3.785,0-6.853,3.068-6.853,6.853C698.558,274.068,695.49,271,691.706,271z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M260.641,508.913c3.785,0,6.853-3.068,6.853-6.852c0,3.784,3.068,6.852,6.852,6.852 c-3.784,0-6.852,3.068-6.852,6.853C267.493,511.981,264.425,508.913,260.641,508.913z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M922.5,328.928c3.784,0,6.852-3.068,6.852-6.852c0,3.785,3.068,6.852,6.852,6.852 c-3.784,0-6.852,3.068-6.852,6.853C929.352,331.996,926.284,328.928,922.5,328.928z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M940.777,343.908c3.117,0,5.643-2.527,5.643-5.643c0,3.117,2.527,5.643,5.643,5.643 c-3.117,0-5.643,2.527-5.643,5.643C946.42,346.434,943.893,343.908,940.777,343.908z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M637.336,110.352c3.117,0,5.643-2.527,5.643-5.644c0,3.117,2.527,5.644,5.643,5.644 c-3.117,0-5.643,2.527-5.643,5.643C642.979,112.878,640.453,110.352,637.336,110.352z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M475.572,273c3.117,0,5.643-2.527,5.643-5.643c0,3.117,2.527,5.643,5.643,5.643 c-3.117,0-5.643,2.527-5.643,5.643C481.216,275.527,478.689,273,475.572,273z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M711.537,258.128c5.51,0,9.976-4.466,9.976-9.976c0,5.51,4.466,9.976,9.976,9.976 c-5.51,0-9.976,4.466-9.976,9.976C721.513,262.594,717.047,258.128,711.537,258.128z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M619.293,130.585c5.51,0,9.976-4.466,9.976-9.976c0,5.51,4.466,9.976,9.976,9.976 c-5.51,0-9.976,4.467-9.976,9.976C629.269,135.051,624.803,130.585,619.293,130.585z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st8",
    d: "M232.064,493.02c5.51,0,9.976-4.466,9.976-9.976c0,5.51,4.467,9.976,9.976,9.976 c-5.51,0-9.976,4.466-9.976,9.976C242.04,497.487,237.574,493.02,232.064,493.02z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M645,337.292c0.005,24.609-19.979,44.594-44.604,44.605c-24.683,0.011-44.737-20.028-44.688-44.723 c0.049-25.212,20.743-44.813,45.163-44.617C625.11,292.752,644.995,312.744,645,337.292z M600.388,377.3 c21.241,0.355,40.084-17.499,40.122-40c0.038-22.024-18.085-40.221-40.16-40.212c-22.531,0.009-40.143,18.865-40.129,40.16 C560.236,359.107,578.592,377.663,600.388,377.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M592.074,327.396c-0.13,1.274-0.562,2.484-0.805,3.734c-0.094,0.484-0.537,0.602-0.905,0.778 c-3.618,1.729-7.466,2.011-11.39,1.791c-1.971-0.11-3.896-0.421-5.639-1.43c-2.993-1.731-4.669-4.377-4.698-7.781 c-0.03-3.498,1.838-6.148,4.858-7.761c4.548-2.429,9.309-2.297,14.043-0.507c2.9,1.096,5.45,2.883,8.146,4.379 c3.174,1.761,5.91,4.175,9.029,6.026c2.78,1.649,5.63,3.073,8.871,3.511c2.913,0.394,5.817,0.485,8.538-0.894 c1.954-0.99,3.488-2.383,3.377-4.793c-0.123-2.676-1.756-4.313-4.158-5.112c-4.623-1.536-9.278-1.437-13.905,0.077 c-1.607,0.526-3.154,1.201-4.858,1.946c0.271-1.26,0.508-2.398,0.764-3.532c0.066-0.293,0.355-0.38,0.588-0.504 c3.591-1.918,7.422-2.957,11.487-3.166c3.402-0.175,6.764-0.121,9.96,1.301c2.741,1.22,5.083,2.873,6.193,5.799 c1.605,4.229-0.07,8.716-4.152,11.311c-2.722,1.731-5.772,2.293-8.914,2.417c-5.826,0.229-11.232-1.109-16.109-4.417 c-2.801-1.899-5.545-3.875-8.307-5.826c-3.322-2.346-6.877-4.374-10.907-5.283c-2.193-0.494-4.423-0.534-6.524,0.541 c-2.223,1.137-3.204,2.713-2.977,5.075c0.212,2.2,1.708,3.418,3.639,4.06c3.113,1.036,6.289,1.063,9.479,0.275 c1.833-0.453,3.467-1.369,5.174-2.118C592.004,327.329,592.038,327.363,592.074,327.396z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M594.326,327.359c1.283,1.027,2.619,2.009,4.026,2.891c0.326,0.205,0.279,0.465,0.211,0.773 c-1.861,8.489-3.722,16.978-5.568,25.47c-0.283,1.303-0.537,2.617-0.726,3.937c-0.359,2.514,0.836,3.993,3.394,4.178 c2.225,0.161,4.45,0.06,6.672-0.141c1.27-0.115,1.5,0.171,1.244,1.397c-0.17,0.813-0.346,1.625-0.518,2.437 c-0.092,0.436-0.265,0.809-0.78,0.83c-3.164,0.132-6.331,0.69-9.491-0.032c-3.438-0.785-5.404-3.152-5.767-6.684 c-0.225-2.187,0.31-4.252,0.763-6.328c2.031-9.302,4.111-18.592,6.177-27.886C594.025,327.924,593.993,327.601,594.326,327.359z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M600.527,321.426c-1.405-1.111-2.777-1.982-4.211-2.751c-0.376-0.202-0.356-0.476-0.28-0.823 c0.876-3.992,1.752-7.983,2.604-11.98c0.129-0.604,0.448-0.872,1.032-0.874c1.097-0.004,2.195-0.02,3.291,0.007 c0.659,0.016,1.067,0.275,0.895,1.063C602.751,311.129,601.66,316.194,600.527,321.426z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M591.972,327.294c0.06-0.061,0.126-0.108,0.187-0.01c0.009,0.014-0.055,0.073-0.085,0.112 C592.038,327.363,592.004,327.329,591.972,327.294z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPollBackgroundImage);
export default __webpack_public_path__ + "static/media/PollBackgroundImage.eb1e702ad61cc56569a9b3afba8e8423.svg";
export { ForwardRef as ReactComponent };